import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import Link    from 'app/components/common/link';
import helpers from 'app/helpers/grant-system';
import paths   from 'app/paths';

class WorkflowCard extends React.PureComponent {

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  get path() {
    if (this.props.onClick) return null;
    if (!this.props.company) return null;
    return paths.cadminGrantWorkflowsEdit(this.props.company.slug, this.props.workflow.id);
  }

  onClick() {
    this.props.onClick && this.props.onClick(this.props.workflow);
  }

  render() {
    const {workflow, className} = this.props;
    const {path} = this;
    const TagType = path ? Link : 'div';
    const linkAttrs = path ? {href: path} : {};

    return (
      <TagType className={`ca-gwf-card ${className}`} onClick={this.onClick} {...linkAttrs}>
        <div className="ca-gwf-card-title">{workflow.title}</div>
        <div className="ca-gwf-card-stages">
          {workflow.stages.map((stage, si) => {
            if (stage.type === helpers.StageTypes.SYSTEM_DECLINED) return null;
            return (
              <div key={stage.id} className="ca-gwf-card-stage">
                {/* <div className="ca-gwf-card-stage-title" style={{ color: `${stage.color}`}}> */}
                <div className="ca-gwf-card-stage-title">
                  <div className="ca-gwf-card-stage-title-num" style={{ backgroundColor: `${stage.color}`}}>{`${si+1}`}</div>
                  <div className="ca-gwf-card-stage-title-label">{stage.title}</div>
                </div>
                <div className="ca-gwf-card-tasks">
                  {stage.tasks.map((task) => {
                    const metaLabel = helpers.taskMetaLabel(task);
                    return (
                      <div key={task.id} className="ca-gwf-card-task">
                        <div className="ca-gwf-card-task-title">
                          <div className="ca-gwf-card-task-icon" />
                          {task.title}
                        </div>
                        <div className="ca-gwf-card-task-meta">{metaLabel}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </TagType>
    );
  }

}

WorkflowCard.propTypes = {
  workflow: PropTypes.object.isRequired,
  company: PropTypes.object,
  onClick: PropTypes.func,
  className: PropTypes.string,
};
WorkflowCard.defaultProps = {
  onClick: null,
  className: '',
};

export default WorkflowCard;
